import IconButton from '@material-ui/core/IconButton';
import AccessibleTooltip from '../../core/AccessibleTooltip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Component } from 'react';
import withGS from '../../core/withGShoc';
import LangConfirmationField from '../../core/LangConfirmationField';
import { Typography } from '@material-ui/core';
import GS from '../../grafsync/grafsync';
import { globalStyles } from '../../core/style/gstheme';
import { displayDate } from '../../core/utils/utils';
import AnnotateIcon from '../../core/icons/Annotate';
import TemplateDialog from '../../application-core/TemplateDialog';

const styles = () => {
  return Object.assign({
    noteTemplateDialog: {
      marginBottom: '2px',
      marginTop: '2px',
      marginRight: '6px'
    }
  }, globalStyles);
};
class Note extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showDialog: false
    };
    this.cancellable = null;
  }

  handleDelete = () => GS.deleteResource(this.props.id, this.props.graph);

  onUpdate = (value) => {
    const lang = Object.keys(this.props.data.comment)[0];
    this.props.onUpdate("comment", value, lang, 0);
  };

  onShowTemplateDialog = () => this.setState({ showDialog: true });

  onHideTemplateDialog = () => this.setState({ showDialog: false });

  render() {

    const { data, isReadOnly, maxLength, property, showTemplates, classes, graph, defaultLang, projectIRI,
      componentIRI, viewLang, propertyTemplates, components, linkedData, associatedTaxonomyProject, projectType,
      ontologyProjectAssociation, projectLang, requiredEntitlement, id } = this.props;
    const { showDialog } = this.state;

    if (!data.comment) return null;

    const lang = Object.keys(data.comment)[0];

    const date = data.created ?
      new Date(data.created)
      :
      data._created ?
        new Date(data._created)
        :
        undefined;
    const dateText = date ? displayDate(date, true) : "Date not available";
    let resourceClasses = Array.isArray(data.type) ? data.type : [data.type];
    // Some of the classes may be aliased so convert to IRIs
    resourceClasses = resourceClasses.map(rc => GS.getIRIfromAlias(rc) || rc);

    return (
      <div style={{ marginBottom: 6 }}>
        <div>
          <div style={{
            display: 'flex',
            width: 'calc(100% - 16px)',
            backgroundColor: '#f8f8f8',
            marginLeft: '6px',
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px',
            borderLeft: 'solid 1px #c0c0c0',
            borderTop: 'solid 1px #c0c0c0',
            borderRight: 'solid 1px #c0c0c0'
          }}>
            <div style={{ flex: '1' }}>
              <Typography style={{ marginTop: 8, marginLeft: 8, color: 'black' }} data-test="note-date" variant="caption">{dateText}</Typography>
            </div>
            {showTemplates &&
              <div
                className={classes.noteTemplateDialog}
                data-test="show-note-template-dialog">
                <AccessibleTooltip title="Show note detail">
                  <span>
                    <IconButton
                      aria-keyshortcuts={this.props.shortcut}
                      color={this.props.color}
                      aria-label="Show note detail"
                      size="small"
                      onClick={this.onShowTemplateDialog}>
                      <AnnotateIcon />
                    </IconButton>
                  </span>
                </AccessibleTooltip>
              </div>
            }
          </div>
          <LangConfirmationField
            dataTest={property + "-note-" + lang}
            ariaLabel={property  + " note with language " + lang + " and id: " + id}
            onDelete={this.handleDelete}
            focus={false}
            onUpdate={this.onUpdate}
            canBeDeleted={true}
            maxLength={maxLength}
            multiline={true}
            text={data.comment[lang]}
            lang={lang}
            isReadOnly={isReadOnly} />
        </div>
        {showDialog &&
          <TemplateDialog
            id={data.id}
            title="Note Detail"
            graph={graph}
            defaultLang={defaultLang}
            projectType={projectType}
            requiredEntitlement={requiredEntitlement}
            projectIRI={projectIRI}
            projectLang={projectLang}
            ontologyProjectAssociation={ontologyProjectAssociation}
            isReadOnly={isReadOnly}
            viewLang={viewLang}
            resourceClasses={resourceClasses}
            associatedTaxonomyProject={associatedTaxonomyProject}
            linkedData={linkedData}
            components={components}
            propertyTemplates={propertyTemplates}
            componentIRI={componentIRI}
            hideDialog={this.onHideTemplateDialog}
          />
        }
      </div>
    );
  }
}

Note.defaultPros = {
  showTemplates: false
};

Note.propTypes = {
  defaultLang: PropTypes.string.isRequired,
  viewLang: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  property: PropTypes.string.isRequired,
  graph: PropTypes.string.isRequired,
  projectIRI: PropTypes.string.isRequired,
  projectType: PropTypes.string.isRequired,
  projectLang: PropTypes.array.isRequired,
  propertyTemplates: PropTypes.array,
  components: PropTypes.array,
  requiredEntitlement: PropTypes.string.isRequired,
  componentIRI: PropTypes.string.isRequired,
  linkedData: PropTypes.array,
  showTemplates: PropTypes.bool,
  associatedTaxonomyProject: PropTypes.array,
  ontologyProjectAssociation: PropTypes.array,
  data: PropTypes.object.isRequired,
  maxLength: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(Note));